<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Development Partner</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step step="2">Development Partner Contact Person Detail</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <DevelopmentPartner v-on:emitForm1="goNextStep"></DevelopmentPartner>
      </v-stepper-content>

      <v-stepper-content v-if="e1==2" step="2">
        <ContactPerson v-on:emitForm2="goNextStep"></ContactPerson>
      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>
</template>

<script>
let commonService = require("../../../services/common.service");

import DevelopmentPartner from './step_forms/developmentPartner';
import ContactPerson from './step_forms/contactPerson';
export default {
  components: {
    DevelopmentPartner,
    ContactPerson,
  },
  data() {
    return {
      e1: 0,
    };
  },
  created() {
   
  },
  methods:{

    goNextStep(num)
    {
      this.e1 = num
    }
  },

};
</script>


// WEBPACK FOOTER //
// src/components/project_info/development_partner/partner_table.vue